<template>
	<div class="device flex-row">
		<div class="poster">
			<img :src="$imgUrl + detail.pictureUrl" />
		</div>
		<div class="info">
			<p class="name">{{detail.title}}</p>
			<p>{{detail.companyName}}</p>
			<p>￥{{detail.emergencyPrice}}/天</p>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: ['detail'],
		data() {
			return {

			}
		}
	}
</script>

<style scoped lang="less">
	.device {
		height: 0.91rem;

		.poster {
			width: 0.99rem;
			height: 0.91rem;
			margin-right: 0.18rem;
			line-height: 0;

			img {
				width: 100%;
				height: 100%;
				border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
			}
		}


		.info {
			flex: 1;
			font-size: .13rem;

			.name {
				font-size: 0.14rem;
				color: #000000;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				/* autoprefixer: off */
				-webkit-box-orient: vertical;
			}

			p:nth-of-type(2) {
				margin-top: 0.08rem;
				font-size: .13rem;
				color: #8D8D8D;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				/* autoprefixer: off */
				-webkit-box-orient: vertical;
			}

			p:nth-of-type(3) {
				margin-top: 0.13rem;
				font-size: .18rem;
				color: #FF4141;
			}
		}
	}
</style>
